/* ORION: the construction of the refreshed mattress page (snippets/orion-mattress-anatomy.liquid). When the large count
   of the layers first comes into view it runs up to its figure (with the ease of the catalogue's own count), the rest
   of the label rises in and the short line before the text draws; once only. The figure in the page stays the real
   one throughout (the running figure is drawn over it), so readers and search engines always get it right. The
   figure zooms with the gallery's own viewer, as the pictures above do. By the owner's rule it moves also when the
   system asks for reduced motion. */
(() => {
  const DURATION = 1100;
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  document.querySelectorAll('[data-orion-anatomy]').forEach((block) => {
    if (block.orionAnatomy) return;
    block.orionAnatomy = true;
    const figure = block.querySelector('[data-orion-anatomy-count]');
    const target = Math.round(Number(figure?.dataset.orionAnatomyCount));
    const watched = figure || block.querySelector('.orion-anatomy__title') || block;
    // Already on screen when the page opens: it stays as it is.
    const box = watched.getBoundingClientRect();
    if (!('IntersectionObserver' in window) || (box.top < innerHeight && box.bottom > 0)) return;

    const counts = Number.isFinite(target) && target > 1;
    block.classList.add('is-armed');
    if (counts) figure.dataset.show = '0';
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      block.classList.add('is-seen');
      if (!counts) return;
      const start = performance.now();
      const frame = (now) => {
        const t = Math.min(1, (now - start) / DURATION);
        if (t < 1) {
          figure.dataset.show = String(Math.round(target * ease(t)));
          requestAnimationFrame(frame);
        } else {
          delete figure.dataset.show;
        }
      };
      requestAnimationFrame(frame);
    }, { threshold: 0.6 });
    observer.observe(watched);
  });

  // The figure grows out of itself into the gallery's viewer, with the same motion as the pictures above, onto the
  // block's own paper, and goes back into place (assets/orion-mattress-viewer-fast.js). Before the viewer is ready the
  // section's plain enlargement answers instead.
  document.querySelectorAll('.orion-anatomy [data-orion-layer-zoom]').forEach((button) => {
    if (button.orionViewer) return;
    button.orionViewer = true;
    button.addEventListener('click', (event) => {
      // A 3D whose materials the theme writes beside it opens in the gallery's viewer with them
      // (assets/orion-construction-labels.js), not as a bare figure.
      if (button.closest('.orion-construction-layout--anatomy')) return;
      const image = button.querySelector('img');
      const viewer = button.closest('[data-orion-mattress-product]')?.querySelector('orion-mattress-gallery orion-image-viewer');
      if (!image || typeof viewer?.openView !== 'function' || !viewer.gallery?._shown) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      viewer.openView({ image, clip: button, returnFocus: button, figure: true, kind: 'diagram', tone: 'light', fullSrc: button.dataset.fullSrc });
    }, { capture: true });
  });
})();
